import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import { ArrowBack } from "@material-ui/icons";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { HV_THEME, HVHeader, HVButton, HVInput, Icons, Card, StatusPill } from "../shared/DesignSystem";
import { savePage } from "../../actions/pageActions";
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { navPath, navSearch } from "../../constants";

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[900]),
    backgroundColor: grey[900],
    "&:hover": {
      backgroundColor: grey[900],
    },
    marginLeft: 30,
    marginTop: 20,
    height: 50,
  },
}))(Button);

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginBottom: 30,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: "transform 0.15s ease-in-out",
    "&:hover": { transform: "scale3d(1.02, 1.02, 1)" },
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginTop: 12,
  },
  cards: {
    marginTop: 50,
    marginLeft: 25,
  },
});
function Group(props) {
  const { groupId } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [projects, setProjects] = useState([]);
  const [tagToDelete, setTagToDelete] = useState('');
  const [openDeleteTag, setOpenDeleteTag] = useState(false);
  const [groupLoading, setGroupLoading] = useState(true);

  const [groupName, setGroupName] = useState("");
  const [tags, setTags] = useState([]);
  const [docType, setDocType] = useState("");
  const [openTagDialog, setOpenTagDialog] = useState(false);
  const [customTag, setCustomTag] = useState('');


  const handleClassification = () => {
    props.history.push(navPath(`/classification/${groupId}`));
  };

  const getGroupStatus = () => {
    axios
      .post("/api/groups/status", { groupId: groupId })
      .then((data) => {
        setProjects(data.data.projects || []);
        setGroupName(data.data.name);
        setTags(data.data.tags || []);
        setDocType(data.data.type);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setGroupLoading(false);
      });
  };

  useEffect(() => {
    if (groupId) {
      getGroupStatus();
    }
    dispatch(savePage(0, 10));
  }, [groupId]);

  const handleGoBack = () => {
    props.history.push({
      pathname: '/',
    })
  };

  const deleteTagSetter = (tag) => {
    setTagToDelete(tag);
    setOpenDeleteTag(true);
  };

  const handleAddTag = (tag) => {
    if (!tag || !tag.trim()) return;
    axios.post('/api/groups/addTagToGroups', { groupIds: [groupId], tag: tag.trim() })
      .then(res => {
        enqueueSnackbar(res.data || 'Tag added', { variant: 'success' });
        setCustomTag('');
        setOpenTagDialog(false);
        getGroupStatus();
      })
      .catch(err => enqueueSnackbar(err?.response?.data || 'Error adding tag', { variant: 'error' }));
  };

  const handleClick = (projectId) => {
    props.history.push({
      pathname: navPath(`/project/${projectId}`),
      state: { fromGroupId: groupId, fromGroupName: groupName },
    });
  };

  const handleBenchmarkClick = (id, name, docType, projectType) => {
    props.history.push({
      pathname: `/project/benchmarks/${id}`,
      search: navSearch(),
      state: {
        id: id,
        name: name,
        docType,
        benchmarkCategory: 'project',
      },
    });
  };

  const handleGroupBenchmarkClick = () => {
    props.history.push({
      pathname: `/group/benchmarks/${groupId}`,
      search: navSearch(),
      state: {
        id: groupId,
        name: groupName,
        docType: docType,
        benchmarkCategory: 'group',
      },
    });
  }

  const TAG_PALETTE = {
    'Production': { bg: '#e7f5ed', fg: '#0f5d2a', bd: '#b7dfca' },
    'Testing':    { bg: '#e6efff', fg: '#1a3a8a', bd: '#b3c9f7' },
    'In Review':  { bg: '#fdf1dc', fg: '#7a4a07', bd: '#f5d68a' },
  };

  const STATUS_TONE = {
    production: { tone: 'ok', label: 'In production' },
    review: { tone: 'warn', label: 'In review' },
    training: { tone: 'info', label: 'Training' },
    draft: { tone: 'neutral', label: 'Draft' },
    failed: { tone: 'danger', label: 'Failed' },
    locked: { tone: 'purple', label: 'Locked' },
    created: { tone: 'neutral', label: 'Created' },
    database_created: { tone: 'neutral', label: 'Created' },
    model_generation_failed: { tone: 'danger', label: 'Generation Failed' },
  };

  if (groupLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

    return (
        <div style={{ background: '#fafafa', minHeight: '100vh', paddingBottom: 60 }}>
            <HVHeader tab="groups" showTabs={false} role={{ name: 'Admin', initials: 'AD', color: '#e6194b', label: 'Admin' }} env="STAGING" onLogout={() => props.history.push('/login')} />
            <div style={{ background: '#fff', borderBottom: '1px solid #ececec', padding: '14px 40px' }}>
                <div style={{ maxWidth: 1440, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <Button variant="outlined" size="small" onClick={handleGoBack} startIcon={<ArrowBack />}>Back</Button>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#666' }}>
                            <span>Groups</span>
                            <span>/</span>
                            <span style={{ color: '#000', fontWeight: 600 }}>{groupName || groupId}</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                        <HVButton variant="ghost" size="sm" icon={<Icons.tag size={13} />} onClick={() => setOpenTagDialog(true)}>Add Tag</HVButton>
                        <HVButton variant="primary" onClick={handleClassification}>Classification</HVButton>
                        <HVButton variant="primary" onClick={handleGroupBenchmarkClick}>Group Benchmarks</HVButton>
                    </div>
                </div>
            </div>

            <div style={{ padding: '24px 40px', maxWidth: 1440, margin: '0 auto' }}>
                {tags && tags.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
                        <Icons.tag size={13} stroke={HV_THEME.mute} />
                        {tags.map(tag => {
                            const tp = TAG_PALETTE[tag] || { bg: '#f1f1f1', fg: '#3a3a3a', bd: '#e0e0e0' };
                            return (
                                <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: tp.bg, border: `1px solid ${tp.bd}`, borderRadius: 99, padding: '4px 10px 4px 12px', fontSize: 11, fontWeight: 600, color: tp.fg }}>
                                    {tag}
                                    <button onClick={() => deleteTagSetter(tag)} title="Remove tag" style={{ background: 'transparent', border: 0, cursor: 'pointer', color: tp.fg, opacity: 0.6, padding: 0, display: 'inline-flex', alignItems: 'center', marginLeft: 2 }}>
                                        <Icons.x size={10} />
                                    </button>
                                </span>
                            );
                        })}
                    </div>
                )}
                {projects.length === 0
                    ? <div style={{ color: HV_THEME.mute, fontSize: 14 }}>No existing projects</div>
                    : <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 14 }}>
                        {projects.map((pro) => {
                            const tone = STATUS_TONE[pro.status] || { tone: 'neutral', label: pro.status };
                            return (
                                <Card key={pro._id} pad={0} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    <div style={{ padding: 16, paddingBottom: 12 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
                                            <div style={{ width: 40, height: 40, borderRadius: 4, background: pro.type === 'card' ? '#eef2ff' : '#fef3e8', color: pro.type === 'card' ? '#3949ab' : '#9a4500', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
                                                {pro.type === 'card' ? <Icons.image size={18} /> : <Icons.doc size={18} />}
                                            </div>
                                            <StatusPill tone={tone.tone} size="sm">{tone.label}</StatusPill>
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, lineHeight: 1.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={pro.name}>{pro.name}</div>
                                        <div style={{ fontSize: 11, color: HV_THEME.mute, fontFamily: "'JetBrains Mono', monospace", marginBottom: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} onClick={() => {
                                            enqueueSnackbar(`${pro._id} copied`, { variant: 'success', autoHideDuration: 800 });
                                            navigator.clipboard.writeText(pro._id);
                                        }}>{pro._id} <Icons.copy size={10} /></div>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, paddingTop: 10, borderTop: '1px solid #f0f0f0' }}>
                                            <div>
                                                <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Type</div>
                                                <div style={{ fontSize: 12, fontWeight: 600 }}>{pro.type?.toUpperCase() || '—'}</div>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: 9, letterSpacing: '0.12em', fontWeight: 700, color: HV_THEME.mute, textTransform: 'uppercase', marginBottom: 3 }}>Updated</div>
                                                <div style={{ fontSize: 12 }}>{pro.updatedAt ? new Date(pro.updatedAt).toLocaleDateString() : '—'}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ borderTop: '1px solid #f0f0f0', padding: '10px 12px', display: 'flex', gap: 6, alignItems: 'center', background: '#fafafa', marginTop: 'auto' }}>
                                        <HVButton size="sm" variant="secondary" style={{ flex: 1 }} onClick={() => handleClick(pro._id)}>Open</HVButton>
                                        <HVButton size="sm" variant="ghost" icon={<Icons.beaker size={12} />} onClick={() => handleBenchmarkClick(pro._id, pro.name, docType, pro.projectType)}>Benchmarks</HVButton>
                                    </div>
                                </Card>
                            );
                        })}
                    </div>
                }
            </div>

      {/* Delete tag dialog */}
      <Dialog open={openDeleteTag} onClose={() => setOpenDeleteTag(false)} maxWidth="xs" fullWidth>
        <DialogTitle style={{ position: 'relative', paddingRight: 48 }}>
          Confirm deletion
          <IconButton onClick={() => setOpenDeleteTag(false)} style={{ position: 'absolute', right: 8, top: 8 }}>
            <Icons.x size={18} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete the tag <strong>{tagToDelete}</strong> from <strong>{groupName}</strong>?
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
          <HVButton variant="ghost" onClick={() => setOpenDeleteTag(false)}>Cancel</HVButton>
          <HVButton variant="danger" onClick={() => {
            setOpenDeleteTag(false);
            axios.post('/api/groups/removeTagFromGroup', { groupId, tag: tagToDelete })
              .then(res => { enqueueSnackbar(res.data, { variant: 'success' }); getGroupStatus(); })
              .catch(err => enqueueSnackbar(err?.response?.data, { variant: 'error' }));
          }}>Remove tag</HVButton>
        </DialogActions>
      </Dialog>

      {/* Add tag dialog */}
      <Dialog open={openTagDialog} onClose={() => { setOpenTagDialog(false); setCustomTag(''); }} maxWidth="xs" fullWidth>
        <DialogTitle style={{ position: 'relative', paddingRight: 48 }}>
          Add tag to group
          <IconButton onClick={() => { setOpenTagDialog(false); setCustomTag(''); }} style={{ position: 'absolute', right: 8, top: 8 }}>
            <Icons.x size={18} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: HV_THEME.mute, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 10 }}>Quick tags</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {['Production', 'Testing', 'In Review'].map(preset => {
                const already = tags && tags.includes(preset);
                const tp = TAG_PALETTE[preset];
                return (
                  <button key={preset} onClick={() => handleAddTag(preset)} disabled={already} style={{
                    background: already ? tp.bg : '#fff',
                    color: already ? tp.fg : HV_THEME.ink,
                    border: `1px solid ${already ? tp.bd : '#e0e0e0'}`,
                    borderRadius: 99, padding: '7px 16px', fontSize: 12, fontWeight: 600,
                    cursor: already ? 'default' : 'pointer', fontFamily: 'inherit',
                    opacity: already ? 0.7 : 1,
                  }}>{preset}{already ? ' ✓' : ''}</button>
                );
              })}
            </div>
          </div>
          <div style={{ fontSize: 10, fontWeight: 700, color: HV_THEME.mute, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 8 }}>Custom tag</div>
          <HVInput
            placeholder="Enter tag name…"
            value={customTag}
            onChange={e => setCustomTag(e.target.value)}
            onKeyPress={e => { if (e.key === 'Enter' && customTag.trim()) handleAddTag(customTag.trim()); }}
          />
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
          <HVButton variant="ghost" onClick={() => { setOpenTagDialog(false); setCustomTag(''); }}>Cancel</HVButton>
          <HVButton variant="primary" disabled={!customTag.trim()} onClick={() => handleAddTag(customTag.trim())}>Add tag</HVButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Group;
